import { useToggle } from '@/hooks';
import { Popover } from '@shopify/polaris';
import { memo, ReactElement, ReactNode } from 'react';

interface CustomTooltipProps {
  activator: ReactElement;
  children: ReactNode;
  maxWidth?: string;
}

const CustomTooltip = ({ activator, children, maxWidth = '16rem' }: CustomTooltipProps) => {
  const [isPopoverActive, togglePopover] = useToggle<boolean>(false);

  return (
    <div onMouseLeave={togglePopover} onMouseEnter={togglePopover}>
      <Popover active={isPopoverActive} activator={activator} onClose={togglePopover} ariaHaspopup={false} sectioned>
        <div style={{ maxWidth }}>{children}</div>
      </Popover>
    </div>
  );
};

export default memo(CustomTooltip);
